/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.view.List,
    view:{
        tag:'ul',
        'class':'tab-list'
    },
    method:{
        init:function () {
            var self = this;

            this.$().on('click','.tab-item',function () {
                var model = self.getModel();
                var index = $(this).attr('data-list-index');
                model.set('activeIndex',index);
            });


        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/tab/TabList.js
// module id = 48
// module chunks = 1 3 7 8 9 10 11 12 14 16 18 19 25 26 28 30